import { Disclosure } from "@headlessui/react";
import ChevronRight from "@material-ui/icons/ChevronRight";
import type { DigitalAsset } from "../types";

interface GoogleSectionProps {
  asset: DigitalAsset;
  canViewBusinessUrl: boolean;
  canViewDescription: boolean;
}

const GoogleSection = ({
  asset,
  canViewBusinessUrl,
  canViewDescription,
}: GoogleSectionProps) => {
  if (!canViewBusinessUrl && !canViewDescription) return null;

  return (
    <Disclosure defaultOpen>
      {({ open }) => (
        <div className="bg-white rounded-lg box-shadow">
          <Disclosure.Button className="disclosureBtn ml-2">
            <ChevronRight
              className={`${
                open ? "transform rotate-90" : " text-gray-500"
              } text-gray-500 w-5 h-5 `}
            />
            <span className="disclosureLabel ml-2">Google</span>
          </Disclosure.Button>

          <Disclosure.Panel className="text-xs">
            <div className="grid grid-cols-2">
              {canViewBusinessUrl && (
                <div className="p-2">
                  <div className="grid grid-cols-1 py-2 px-4 space-y-2">
                    <label className="mx-2 expandedLabel fontExpand">
                      Google Business URL:
                    </label>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mx-2 expandedData fontExpand text-blue-500 underline break-all"
                      href={
                        asset.google_Business_Url__C &&
                        asset.google_Business_Url__C !== "NULL"
                          ? asset.google_Business_Url__C
                          : ""
                      }
                    >
                      {asset.google_Business_Url__C !== "NULL"
                        ? asset.google_Business_Url__C
                        : ""}
                    </a>
                  </div>
                </div>
              )}

              {canViewDescription && (
                <div className="p-2">
                  <div className="grid grid-cols-1 py-2 px-2 space-y-2">
                    <label className="mx-4 expandedLabel fontExpand">
                      Google Description:
                    </label>
                    <div className="mx-4 expandedData fontExpand">
                      {asset.google_Description__C !== "NULL"
                        ? asset.google_Description__C
                        : ""}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
};

export default GoogleSection;